import * as angular from "angular";
import { VeriDate } from "@services/veriDate.service";
import "./userActivityChart.scss";
import { IUser } from "../../../../../interfaces/IUser";
import { ILoginHistory, LoginHistoryService } from "@services/loginHistory.service.ajs";
import { TranslationService } from "@services/translation.service";
import { MessageDialogService } from "@services/messageDialog.service";
import * as moment from "moment";
import { IDayMap } from "@app/main/modules/dashboard/_models/IDayMap";


class UserActivityChartComponentController implements angular.IComponentController {
    user: IUser;

    loginHistoryForCurrentUser: ILoginHistory[];
    loginData: any[];
    loginDataExists: boolean = false;
    days: IDayMap[];

    loading: boolean;

    static $inject = ["veriDate", "loginHistoryService", "translationService", "messageDialogService"];

    constructor(
        private readonly veriDate: VeriDate,
        private readonly loginHistoryService: LoginHistoryService,
        private readonly translationService: TranslationService,
        private readonly messageDialogService: MessageDialogService
    ) {
    }

    $onInit(): void {
        this.getDays();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["user"]) {
            this.displayLoginHistory();
        }        
    }

    displayLoginHistory() {
        this.loading = true;
        this.loginHistoryForCurrentUser = null;
        const startTime: moment.Moment = this.veriDate.createMoment(new Date()).subtract(30, "days");
        const endTime: moment.Moment = this.veriDate.createMoment(new Date());
        this.loginHistoryService.getAllLoginHistoryForUser(this.user.Id, startTime, endTime)
            .then(history => {
                if (!history) {
                    return;
                }
                this.loginHistoryForCurrentUser = history;
            }).catch((err) => {
                this.messageDialogService.handleError(err, this.translationService.t("users.UnableToLoadUserLoginHistory"));
            }).finally(() => {
                this.loading = false;
                this.createLoginHistoryData(30);
            });
    }

    createLoginHistoryData(numberOfDays: number) {
        this.loginDataExists = false;
        this.loginData = [];
        for (let i = 0; i < numberOfDays; i++) {
            let date = this.veriDate.createMoment(new Date()).subtract(i, "days");
            let datesWithLogin = this.loginHistoryForCurrentUser.filter(login => {
                return this.veriDate.createMoment(login.CreatedTime).isSame(date, 'day');
            })
            if (datesWithLogin.length) {
                this.loginDataExists = true;
            }
            var tooltipText = this.translationService.t('users.LoginsTooltip', [datesWithLogin.length, date.format("dddd, MMMM Do YYYY")])
            this.loginData.unshift({
                Date: date.format("dddd, MMMM Do YYYY"),
                Logins: [...datesWithLogin],
                ClassName: `density-${datesWithLogin.length}`,
                Tooltip: tooltipText
            })
            if (i === numberOfDays - 1 && this.loginDataExists) {
                // Add blank entries to offset start of cells to line up with day headers (starts at Sun)
                for (let i = 0; i < date.day(); i++) {
                    this.loginData.unshift({
                        Date: null,
                        Logins: [],
                        ClassName: `empty-day`,
                        Tooltip: ''
                    })
                }
            }
        }
    }

    private getDays() {
        this.days = [];

        for (let i = 0; i < 7; i++) {
            this.days[i] = {
                day: i,
                dayString: this.veriDate.getDayOfWeek(i, true)
            };
        }
    }
}

export class UserActivityChartComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            user: "<"
        };

        this.controller = UserActivityChartComponentController;
        this.template = require(`./userActivityChart.html`);
    }
}
